import { Link } from "react-router-dom";

export const VIEWS = [["standings", "STANDINGS"], ["form", "FORM"], ["homeaway", "HOME / AWAY"], ["division", "DIVISION"], ["conference", "CONFERENCE"]];
const fmt = (v) => (v == null ? "—" : Number(v).toFixed(1));
const gb = (v) => (v == null ? "-" : Number(v).toFixed(1));

const COLS = {
  standings: ["HOME", "AWAY", "DIV", "CONF", "PPG", "OPP PPG", "DIFF", "STRK"],
  form: ["L10", "STRK"],
  homeaway: ["HOME", "AWAY"],
  division: ["DIVISION", "DIV"],
  conference: ["CONF", "SEED"],
};

function cell(col, r) {
  switch (col) {
    case "HOME": return r.home || "—";
    case "AWAY": return r.road || "—";
    case "DIV": return r.div_record || "—";
    case "CONF": return r.conf_record || "—";
    case "PPG": return fmt(r.ppg);
    case "OPP PPG": return fmt(r.opp_ppg);
    case "DIFF": return <span className={r.diff >= 0 ? "ncs-positive" : "ncs-negative"}>{r.diff > 0 ? "+" : ""}{fmt(r.diff)}</span>;
    case "STRK": return <span className={(r.streak || "").startsWith("W") ? "ncs-positive" : "ncs-negative"}>{r.streak || "—"}</span>;
    case "L10": return r.last10 || "—";
    case "DIVISION": return r.division;
    case "SEED": return r.seed || "—";
    default: return "";
  }
}

const Form = ({ form }) => (
  <div className="ncs-form">
    {form.map((f, j) => (
      <span key={j} className={f.win ? "win" : "loss"} title={`${f.win ? "W" : "L"} ${f.home ? "vs" : "@"} ${f.opp} ${f.score}`}>{f.win ? "W" : "L"}</span>
    ))}
  </div>
);

export function ConferenceTable({ id, title, rows, view }) {
  if (!rows.length) return null;
  const cols = COLS[view];
  return (
    <section className="ncs-panel" data-testid={`standings-conf-${id}`}>
      <h2><span className={`ncs-${id}`} />{title.toUpperCase()}</h2>
      <div className="ncs-scroll">
        <table>
          <thead><tr><th>#</th><th className="ncs-team-col">TEAM</th><th>W</th><th>L</th><th>PCT</th><th>GB</th>{cols.map((c) => <th key={c}>{c}</th>)}<th>FORM</th></tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.team_id} className={r.rank === 6 ? "ncs-cut-playoff" : r.rank === 10 ? "ncs-cut-playin" : ""} data-testid={`standings-row-${r.team_id}`}>
                <td className="ncs-seed">{r.rank}</td>
                <td className="ncs-team-col">
                  <Link to={`/teams/${r.team_id}`} data-testid={`standings-team-link-${r.team_id}`}>
                    {r.logo ? <img className="ncs-logo" src={r.logo} alt="" loading="lazy" /> : <span className="ncs-logo-fallback">{r.code}</span>}
                    <span>{r.full_name}</span><span className="ncs-chevron">›</span>
                  </Link>
                </td>
                <td>{r.wins}</td><td>{r.losses}</td><td>{r.pct}</td><td>{gb(r.conf_gb)}</td>
                {cols.map((c) => <td key={c}>{cell(c, r)}</td>)}
                <td><Form form={r.form || []} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
